import React from "react";
import { donutColors } from "../../Colors/colors";
import { MachinesByGroup } from "../../Types/dashboardTypes";
import CustomDonutChart from "./myDonutChart";

interface AllDonutChartsProps {
  isShowAllMachines: boolean;
  machinesByGroup: MachinesByGroup[];
}
const AllDonutCharts: React.FC<AllDonutChartsProps> = (props) => {
  const { isShowAllMachines, machinesByGroup } = props;
  const repeatedDonutColors = new Array(100).fill(donutColors).flat();
  const jsxCharts: JSX.Element[] = [];
  machinesByGroup.map((value, index) => {
    jsxCharts.push(
      <div key={index} className="donut-chart-outer-div-show-all-view">
        <div className="donut-chart-machine-name">{value.machineName}</div>
        <div style={{ textAlign: "center" }}>
          <CustomDonutChart
            isShowAllMachines={isShowAllMachines}
            diameter={143}
            color={repeatedDonutColors[index]}
            selectedMachine={value}
          />
        </div>
      </div>
    );
  });

  return <React.Fragment>{jsxCharts}</React.Fragment>;
};

export default AllDonutCharts;
